module.exports = __webpack_public_path__ + "img/金融自媒体人才库.602406f3.png";